import React from 'react';
import {css, StyleSheet} from 'aphrodite/no-important';
import AvastCookieBar from "./AvastCookieBar";
import GridStyle from "../styles/styles";
import Config from "../config/Config";

const CookieBar = ({onAccept}) => {
    const styles = StyleSheet.create({
        frame: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            zIndex: 5000,
            width: '100%',
            overflow: 'hidden',
            background: Config.colors.COOKIES_BAR,
            textAlign: 'center',
            color: '#FFF',
            ...GridStyle.setRow(6),
            transition: 'max-height 1s ease-in-out',
        },
        sizer: {
            paddingTop: 25,
            paddingBottom: 25,
            maxWidth: 1056,
            margin: '0 auto',
            textAlign: 'left',
            position: 'relative',
            paddingLeft: 20,
            paddingRight: 20
        }
    });

    return (
        <div className={css(styles.frame)}>
            <div className={css(styles.sizer)}>
                <AvastCookieBar onAccept={onAccept}/>
            </div>
        </div>
    );
};

export default CookieBar;
